const otherProps = {"light":true};
export default otherProps;
